import { initializeApp } from 'firebase/app';
import { getToken, getMessaging, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: 'AIzaSyDGSDQyksZqKAqITt04tQCKZTI1b0NRoMM',
  authDomain: 'thom-connect.firebaseapp.com',
  projectId: 'thom-connect',
  storageBucket: 'thom-connect.firebasestorage.app',
  messagingSenderId: '663547195606',
  appId: '1:663547195606:web:e7eb2572489d541b439977',
};

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

export { onMessage, messaging, getToken };
